(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-promo-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('nc-promo-countdown')) return;

    var TZ = 'Europe/Bucharest';

    // Offset (ms) of Romanian time vs UTC at a given instant.
    function tzOffset(date) {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: TZ, hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      }).formatToParts(date);
      var v = {};
      parts.forEach(function (p) { v[p.type] = p.value; });
      var asUtc = Date.UTC(+v.year, +v.month - 1, +v.day, +v.hour, +v.minute, +v.second);
      return asUtc - date.getTime();
    }

    // Accepts "2026-10-05 23:59", "2026-10-05T23:59" or "05.10.2026 23:59".
    function parseRoTime(str) {
      if (!str) return null;
      var m = str.trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
      var y, mo, d, h, mi;
      if (m) { y = +m[1]; mo = +m[2]; d = +m[3]; h = m[4] ? +m[4] : 23; mi = m[5] ? +m[5] : 59; }
      else {
        m = str.trim().match(/^(\d{1,2})[.\/](\d{1,2})[.\/](\d{4})(?:\s+(\d{1,2}):(\d{2}))?$/);
        if (!m) return null;
        d = +m[1]; mo = +m[2]; y = +m[3]; h = m[4] ? +m[4] : 23; mi = m[5] ? +m[5] : 59;
      }
      var guess = Date.UTC(y, mo - 1, d, h, mi, 0);
      return guess - tzOffset(new Date(guess));
    }

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    class NcPromoCountdown extends HTMLElement {
      connectedCallback() {
        this.end = parseRoTime(this.dataset.end);
        this.start = parseRoTime(this.dataset.start);
        if (this.dataset.end && this.end === null) { this.hidden = false; return; }
        if (this.end === null) return;
        this.nums = {};
        this.querySelectorAll('[data-unit]').forEach((el) => { this.nums[el.dataset.unit] = el; });
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      tick() {
        var now = Date.now();
        if (this.start && now < this.start) { this.hidden = true; return; }
        var left = this.end - now;
        if (left <= 0) {
          clearInterval(this.timer);
          if (this.dataset.hideExpired === 'true') { this.hidden = true; return; }
          var timer = this.querySelector('.nc-promo__timer');
          if (timer) timer.textContent = this.dataset.expiredText || '';
          this.hidden = false;
          return;
        }
        var s = Math.floor(left / 1000);
        this.nums.d.textContent = pad(Math.floor(s / 86400));
        this.nums.h.textContent = pad(Math.floor((s % 86400) / 3600));
        this.nums.m.textContent = pad(Math.floor((s % 3600) / 60));
        this.nums.s.textContent = pad(s % 60);
        this.hidden = false;
      }
    }
    customElements.define('nc-promo-countdown', NcPromoCountdown);
  })();

  } catch(e) { console.error(e); }
})();
})();
